<div class="dialog-wrapper">
    <div class="dialog-content">
        <div class="close" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </div>
        <img [src]="imgSrc" alt="preview">
    </div>
</div>